import * as React from 'react';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import { useHistory } from 'react-router-dom';

import { SignUp } from '@app/modules/SignUpFlow/modules/SignUp';

import { StatSection } from '../subcomponents/StatSection';
import { useIntersectionObserver } from './utils';

function HomePageWelcome() {
  const { isIntersecting, ref } = useIntersectionObserver();
  const SIGN_IN_URL = '/users/sign_in';
  const SIGN_UP_URL = '/users/sign_up';

  const history = useHistory();

  const redirectUrl = (url: string) => {
    return (): void => {
      history.push(url);
    };
  };

  return (
    <Grid
      item={true}
      container={true}
      className="home-page__welcome-container max-container"
      justifyContent={'center'}
    >
      <Grid item={true} xs={10} sm={5} lg={4} className="home-page__welcome-description-box">
        <div
          className={`home-page__welcome-description swipe-right-section ${
            isIntersecting ? 'is-visible' : ''
          }`}
          ref={ref}
        >
          <h1 data-qa="home-page__main-title">
            Turn your craft <br />
            into currency
          </h1>
          <p>Skillz empowers developers to monetize their games through skill-based competition</p>

          <div className="home-page__welcome-button-box">
            <Button
              id={`home-page__welcome-button-box-signup`}
              className="home-page__welcome-button-box-button home-page__welcome-button-box-signup"
              variant="contained"
              onClick={redirectUrl(SIGN_UP_URL)}
              data-qa={`home-page__welcome-button-box-signup`}
              size={'medium'}
              sx={(theme) => ({
                width: '128px',
                [theme.breakpoints.down('sm')]: {
                  display: 'block',
                },
                [theme.breakpoints.up('sm')]: {
                  display: 'none',
                },
              })}
            >
              SIGN UP
            </Button>
            <Button
              id={`home-page__welcome-button-box-button`}
              className="home-page__welcome-button-box-button"
              variant="text"
              color="info"
              onClick={redirectUrl(SIGN_IN_URL)}
              data-qa={`home-page__welcome-button-box-button`}
              size={'medium'}
              sx={(theme) => ({
                width: '128px',
                [theme.breakpoints.down('sm')]: {
                  display: 'block',
                },
                [theme.breakpoints.up('sm')]: {
                  display: 'none',
                },
              })}
            >
              LOGIN
            </Button>
          </div>
        </div>
      </Grid>
      <Grid
        item={true}
        xs={10}
        sm={5}
        lg={4}
        className="home-page__welcome-signup-form-container-grid"
      >
        <div className="home-page__welcome-signup-form-container">
          <h2 className="home-page__welcome-signup-form-container-header">Sign Up</h2>
          <SignUp />
        </div>
      </Grid>

      <StatSection />
    </Grid>
  );
}

export { HomePageWelcome };
